import Background from "./Background";

export default function About() {
    return <Background />;
}